"use client";
'use strict';

var React = require('react');
require('@sravni/design-system-theme');
require('js-cookie');
require('@sravni/utils/lib/consts');
require('@sravni/utils/lib/theme');
var Context = require('../providers/ThemeProvider/Context.js');

/**
 * React hook that allows to work with theme
 *
 * @example
 * ```javascript
 * const [ theme, setTheme ] = useTheme()
 * ```
 */
function useTheme() {
    const context = React.useContext(Context.ThemeContext);
    if (!context || Object.keys(context).length === 0)
        throw new Error('useTheme hook must be inside ThemeProvider');
    const { theme, setTheme } = context;
    return [theme, setTheme];
}

exports.useTheme = useTheme;
//# sourceMappingURL=useTheme.js.map
